import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import InnosightsIllustration from "./Projectsllustration"

const InnosightsAnimation = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])

  const text = `Projects Team`
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <InnosightsIllustration />}
        <span className={styles.para}>
          {" "}
          Projects team will be a first-rate platform for you to acquire and
          assimilate various points about the fantastic technological
          transformations. You will get a glimpse of incredible innovations, a
          chance to discuss and know about the potential technological changes,
          excellent opportunity to put efforts on your brain to search for such
          topics. The more you spend here, the more doubts about your future
          project ideas and implementations get resolved.&nbsp;
          <a href="/team/project_team" rel="noreferrer">
            Know More...
          </a>
        </span>
      </div>
      {width > 768 && <InnosightsIllustration />}
    </div>
  )
}

export default InnosightsAnimation
